import { QueryFn } from '@percent/workplace-giving/common/hooks/useQuery/useQuery.types'

export type ContentTagEntityType = 'opportunity' | 'fundraiser' | 'giving_campaign'

export type ContentTag = {
  name: string
  id: string
}

type ContentTagsParams = {
  entityType: ContentTagEntityType
  entityId: string
}

export const getContentTags: QueryFn<[string, ContentTagsParams], ContentTag[]> = async (
  client,
  [_, { entityType, entityId }]
) => {
  const { data } = await client.get<{ data: ContentTag[] }>(`v1/tags/${entityType}/${entityId}`, {
    withCredentials: true
  })

  return data.data
}
